/* eslint-disable @typescript-eslint/member-delimiter-style */
import * as LoginAuthentication from './login.authentication'

import * as Permission from './permission'

export interface Service {
  LoginAuthentication: LoginAuthentication.ServiceHandler
  Permission: Permission.ServiceHandler
}

const service: Service = {
  LoginAuthentication: LoginAuthentication.serviceHandler,
  Permission: Permission.serviceHandler
}

export default service
